import rental_warehouse from './rental_warehouse';
import warehouse from './warehouse';

export default {
  rental_warehouse,
  warehouse,
};
